import * as oauth from 'oauth4webapi';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
import Public from '../../API/Public';
import { REDIRECT_URI, AUTH_CONFIG, CLIENT_ID } from '../../app_constants';
import Loading from '../../UI/Loading';
import bemClassName from '../../utils/bem';
import { removeToken } from '../../utils/authStatus';
import { checkAuthStatus } from '../../store/reducers/profile/autorizationStatutsSlice';
import { AppDispatch } from '../../store';

const auth = bemClassName('auth');

const useAppDispatch = () => useDispatch<AppDispatch>();

const Auth = () => {
  const navigate = useNavigate();
  const [tokenError, setTokenError] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const getToken = async () => {
    const currentUrl = new URL(window.location.href);
    const params = oauth.validateAuthResponse(
      AUTH_CONFIG,
      { client_id: CLIENT_ID },
      currentUrl,
      oauth.skipStateCheck,
    );

    try {
      if (oauth.isOAuth2Error(params)) {
        throw new Error('OAuth 2.0 error');
      }
      const codeVerifier = localStorage.getItem('code_verifier');

      if (!codeVerifier) {
        throw new Error('Нет code verifier');
      }

      const result = await Public.getToken(
        params.get('code') as string,
        REDIRECT_URI,
        codeVerifier,
      );
      if (result.access_token && result.expires_in && result.id_token) {
        const expiresTime = Date.now();
        const expiresInSeconds = Number(result.expires_in);
        const tokenExpirationTime = expiresTime + +expiresInSeconds * 1000;

        const stateObject = JSON.parse(params.get('state') as string);
        localStorage.setItem('refresh_token', String(result.refresh_token));
        localStorage.setItem('tokenExpirationTime', String(tokenExpirationTime));
        localStorage.setItem('id_token', String(result.id_token));
        localStorage.setItem('tokenLifetime', String(expiresInSeconds));
        localStorage.setItem('access_token', String(result.access_token));
        dispatch(checkAuthStatus());
        if (stateObject.redirectUrl && !stateObject.redirectUrl.startsWith('/auth')) {
          navigate(stateObject.redirectUrl);
        } else {
          navigate('/');
        }
      } else {
        console.error('Не удалось получить access_token');
        throw new Error('Не получен токен');
      }
    } catch {
      removeToken();
      setTokenError(true);
    }
  };

  let stop = false;

  useEffect(() => {
    if (!stop) {
      stop = true;
      getToken();
    }
  }, []);

  return !tokenError ? (
    <Loading externalClassName={auth()} />
  ) : (
    <>
      <h1>Ошибка получения токена</h1>
    </>
  );
};

export default Auth;
